import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import TeamMemberView from 'components/TeamMemberView'

export const getStaticPaths = async ({ locales }) => {
  const pageQueries = await getClient().fetch(
    groq`*[_type in ["teamMember"] && defined(slug.current)]{slug}`
  )

  const pagePaths = []
  pageQueries.forEach((page) => {
    locales.forEach((locale) => {
      pagePaths.push({
        params: {
          slug: page.slug.current,
          locale,
        },
      })
    })
  })
  return { paths: pagePaths, fallback: 'blocking' }
}

const query = groq`*[_type == "teamMember" && slug.current == $slug][0]{..., teamGroup[]->}`
const postsQuery = groq`*[_type == "post" && locale == $locale && ($slug in authors[]->slug.current || $slug in relatedProfiles[]->slug.current)] | order(publishedAt desc)[0...12]`

export const getStaticProps = async ({ locale, params, preview = false }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )
  const teamMember = await getClient(preview).fetch(query, {
    slug: params.slug,
  })
  const posts = await getClient(preview).fetch(postsQuery, {
    slug: params.slug,
    locale,
  })

  if (!teamMember) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      translation,
      teamMember,
      posts,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default TeamMemberView
